import {Observable} from 'rxjs';
import type {ActionsObservable} from 'redux-observable';
import {switchMap, map, catchError} from 'rxjs/operators';

import type {AccountsApiResponse} from '../types';
import {failFetchById, resolveFetchById, ActionTypes} from './accounts-actions';
import type {AccountsAction, ActionFetchByIdRequest} from './accounts-actions';
import * as apiMethods from './accounts-api';

export const makeFetchAccountByIdEpic =
    (fetchAccountById: typeof apiMethods.fetchAccountById = apiMethods.fetchAccountById) =>
    (action$: ActionsObservable<AccountsAction>) =>
        action$.ofType(ActionTypes.ACCOUNTS_FETCH_BY_ID_REQUEST).pipe(
            // @ts-ignore
            switchMap((action: ActionFetchByIdRequest) => {
                return Observable.from(fetchAccountById(action.payload)).pipe(
                    map((response: AccountsApiResponse) => resolveFetchById(response)),
                    catchError((error) => Observable.of(failFetchById(error)))
                );
            })
        );
